<template>
  <v-toolbar flat class="mb-4">
    <v-toolbar-title>
      {{ $t("silos.siloProperty.title") }}
      <span></span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            color="accent"
            fab
            small
            router
            to="/properties"
            v-on="on"
          >
            <v-icon dark>mdi-silo</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("silos.siloProperty.title") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }" v-if="permitted('Silos.Create')">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/properties/create"
            v-on="on"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("silos.siloProperty.create") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "SiloPropertyToolbar",
};
</script>